import React from 'react';
import { Compass } from 'lucide-react';
export function Footer() {
  return <footer className="py-10 px-6 md:px-12 bg-navy border-t border-steel" data-id="element-40">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 text-[11px] font-semibold tracking-[0.15em] uppercase text-muted" data-id="element-41">
        <div className="flex items-center space-x-3" data-id="element-42">
          <Compass className="w-5 h-5 text-gold" strokeWidth={1.5} data-id="element-43" />
          <span className="font-display text-base tracking-tight text-cream" data-id="element-44">
            BPF LLC
          </span>
        </div>

        <div className="text-center md:text-right" data-id="element-45">
          © 2025 BPF LLC · Todos los derechos reservados · Wyoming, EE.UU.
        </div>
      </div>
    </footer>;
}